import { Injectable } from '@angular/core';
import { NotifierComponent } from './notifier.component';
import { timer } from 'rxjs';
import { first } from 'rxjs/operators';
import { NotificationType } from './notification-type.enum';
import {
    MatSnackBar,
    MatSnackBarConfig,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root',
})
export class NotifierService {
    constructor(private snackBar: MatSnackBar) {}

    notify(
        type: NotificationType,
        message?: string,
        options: NotificationOptions = {},
    ) {
        const snackOptions: MatSnackBarConfig = {
            panelClass: 'custom-snack',
            verticalPosition: options?.verticalPosition || 'bottom',
            horizontalPosition: options?.horizontalPosition || 'center',
            duration: options.duration || 5000,
            data: {
                message,
                title: options.title,
                type,
            },
        };

        timer(options.delay || 0)
            .pipe(first())
            .subscribe(() => {
                this.snackBar.openFromComponent(
                    NotifierComponent,
                    snackOptions,
                );
            });
    }
}

export interface NotificationOptions {
    title?: string;
    duration?: number;
    delay?: number;
    customClass?: string;
    horizontalPosition?: MatSnackBarHorizontalPosition;
    verticalPosition?: MatSnackBarVerticalPosition;
}
